import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    scroll(opt, tar) {
      const { tag = 'div', viewClass = '', wrapClass = '', barClass = '' } = opt
      return $(`
      <div class="lt-scrollbar ${barClass}">
        <div id="wrap" class="scrollbar__wrap ${wrapClass}" style="margin-bottom: -17px; margin-right: -17px;">
          <${tag} id="view" class="scrollbar__view ${viewClass}"></${tag}>
        </div> 
        <div class="scrollbar__bar is-horizontal">
          <div class="scrollbar__thumb" style="transform: translateX(0%);"></div>
        </div>
        <div class="scrollbar__bar is-vertical">
          <div class="scrollbar__thumb" style="transform: translateY(0%);"></div>
        </div>
      </div>`)
    },
  },
  updater: {
    // 基本功能: 内嵌
    slot(value, opt, tar, node) {
      const { view } = tar.members
      view.html(value)
    },
  },
}

export default class Scrollbar extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      slot: '', // 基本功能: 内嵌
    }
    this.events = {
      scroll: null, // 滚动事件
      leave: null, // 鼠标离开控件区域事件
    }
    this.settings = Object.assign({}, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.scroll(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    const { wrap } = this.members
    wrap.scroll($.proxy(this.scroll, this))
    wrap.mouseleave($.proxy(this.leave, this))
  }

  scrollTop(value) {
    const { wrap } = this.members
    if (value === undefined) {
      return wrap.scrollTop()
    } else {
      wrap.scrollTop(value)
      return this
    }
  }
}
